import React, { useMemo } from 'react';
import { useParams } from 'react-router-dom';
import { Box, Typography } from '@mui/material';
import PageTitle from '../components/PageTitle';
import ClientSpendTile from './components/ClientSpendTile';
import ClientWipTile from './components/ClientWipTile';
import ClientSamplesSubmittedTile from './components/ClientSamplesSubmittedTile';
import ClientOnTimeReportingTile from './components/ClientOnTimeReportingTile';
import ClientAverageTatTile from './components/ClientAverageTatTile';

import './Dashboard.scss';

const ClientDashboard = () => {
  const { limsDatabase, clientReference } = useParams();

  const pageTitle = `${clientReference} (${limsDatabase}) Dashboard`;

  const dateRangeLabel = useMemo(() => {
    const today = new Date();
    const fromDate = new Date();
    fromDate.setFullYear(today.getFullYear() - 1);

    const formatDate = (date: Date) =>
      date.toLocaleDateString('en-AU', { day: 'numeric', month: 'short', year: 'numeric' });

    return `${formatDate(fromDate)} – ${formatDate(today)}`;
  }, []);

  return (
    <>
      <PageTitle pageTitle={pageTitle} />
      <Box>
       <Typography variant="body1" className="dashboardDateRange">
          Showing data from {dateRangeLabel}
        </Typography>

        <Box className="dashboardTopRow">
          <ClientAverageTatTile limsDatabase={limsDatabase} clientReference={clientReference} />
          <ClientOnTimeReportingTile limsDatabase={limsDatabase} clientReference={clientReference}  />
        </Box>
        <Box className="dashboardBottomRow">
          <ClientWipTile limsDatabase={limsDatabase} clientReference={clientReference} />
          <ClientSamplesSubmittedTile limsDatabase={limsDatabase} clientReference={clientReference}  />
          <ClientSpendTile limsDatabase={limsDatabase} clientReference={clientReference} />
        </Box>
      </Box>
    </>
  );
};

export default ClientDashboard;
